import { useTranslation } from "react-i18next";
import CustomTextAreaInput from "../../../components/FormComponents/CustomTextAreaInput";
import { IIncident } from "../../../core/interfaces/incident";
import FormProvider from "./FormProvider/FormProvider";


export function CauseOfEventForm(props: { editMode: boolean, newIncident: IIncident, onChange: (e: any) => void }) {
    const {t} = useTranslation();
    return <FormProvider controlId={'formCauseOfEvent'} title={t('CauseOfEventForm.REASON_1')} colAs={props.editMode ? 'large' : 'sm'}>
        <CustomTextAreaInput
            isEditMode={props.editMode}
            rows={5}
            testId={'formCauseOfEvent'}
            name={"causeOfEvent"}
            value={props.newIncident.causeOfEvent ?? ''}
            onChange={props.onChange}
            required
        />
    </FormProvider>
}
